export const AVAILABILITIES_PATH = "/v1/workers/availability";

export const AVAILABILITY_DATE_FORMAT = "yyyy-MM-dd";
